<gtd-widgets-info-layout [isLoading]="isLoading" (onRefresh)="getData()">
  <p500-ui-cube-preloader *ngIf="isLoading"></p500-ui-cube-preloader>
  <div class="c-widget--info c-widget--info--white" *ngIf="!isLoading" [ngClass]="customClass">
    <ul>
      <li class="title" i18n="@@common.basic_information">Basic Information</li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.name">Name</span>: </span>
          <span class="value">
            <gtd-ui-field-default-string-or-empty [data]="data.name"></gtd-ui-field-default-string-or-empty>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.brand">Brand</span>: </span>
          <span class="value">
            <gtd-ui-field-default-link
              [link]="['/app/settings/crm-advertiser-brands', data?.advertiser_brand?.id]"
              [displayData]="data?.advertiser_brand?.name"
              [relationData]="data?.advertiser_brand?.id"
              [rbacProperty]="RbacPermissionsConstant.PAGES_TABLE_ADVERTISERS"
            >
            </gtd-ui-field-default-link>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.advertiser">Advertiser</span>: </span>
          <span class="value">
            <gtd-ui-field-default-link
              [link]="['/app/advertisers/advertisers', data.advertiser.id]"
              [displayData]="data.advertiser.name"
              [relationData]="data.advertiser.id"
              [rbacProperty]="RbacPermissionsConstant.WIDGETS_ADVERTISER_PROFILE"
            >
            </gtd-ui-field-default-link>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.currency">Currency</span>: </span>
          <span class="value">
            <gtd-ui-field-default-currency [data]="data.currency_code"></gtd-ui-field-default-currency>
          </span>
        </p>
      </li>
      <li *ngIf="data.hasOwnProperty('conversion_tracking_type')">
        <p>
          <span class="key"> <span i18n="@@offer.tracking_type">Tracking Type</span>: </span>
          <span class="value">
            <gtd-ui-field-special-conversion-tracking-type [data]="data.conversion_tracking_type">
            </gtd-ui-field-special-conversion-tracking-type>
          </span>
        </p>
      </li>
      <li *ngIf="data.hasOwnProperty('country_codes')">
        <p>
          <span class="key"> <span i18n="@@common.country">Country</span>: </span>
          <span class="value">
            <gtd-ui-field-default-countries [data]="data.country_codes"> </gtd-ui-field-default-countries>
          </span>
        </p>
      </li>
      <li *ngIf="data.hasOwnProperty('language_codes')">
        <p>
          <span class="key"> <span i18n="@@common.language">Language</span>: </span>
          <span class="value">
            <gtd-ui-field-default-languages [data]="data.language_codes"></gtd-ui-field-default-languages>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key"> <span i18n="@@offer.tracking_domain">Tracking Domain</span>: </span>
          <span class="value">
            @if (data.trackingDomain) {
            <gtd-ui-field-default-string-whitespace-or-empty-with-copy
              [data]="data.trackingDomain.content"
              [length]="25"
            ></gtd-ui-field-default-string-whitespace-or-empty-with-copy>
            } @else {
            <gtd-ui-field-default-string-whitespace-or-empty-with-copy
              i18n-data="@@common.default"
              data="Default"
              [length]="25"
            ></gtd-ui-field-default-string-whitespace-or-empty-with-copy>
            }
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key"> <span i18n="@@offer.redirect_type">Redirect Type</span>: </span>
          <span class="value">
            <gtd-ui-field-default-string-whitespace-or-empty-with-copy
              [data]="data.redirect_type"
              [length]="25"
            ></gtd-ui-field-default-string-whitespace-or-empty-with-copy>
          </span>
        </p>
      </li>
    </ul>
    <ul>
      <li class="title" i18n="@@common.settings">Settings</li>
      <li *ngIf="data.hasOwnProperty('is_private')">
        <p>
          <span class="key"> <span i18n="@@common.is_private">Is Private</span>: </span>
          <span class="value">
            <gtd-ui-field-default-boolean [data]="data.is_private"></gtd-ui-field-default-boolean>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.activity">Activity</span>: </span>
          <span class="value">
            <gtd-number-status [data]="data.status"></gtd-number-status>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key"> <span i18n="@@offer.is_white">Is White</span>: </span>
          <span class="value">
            <gtd-ui-field-default-boolean [data]="data.is_white"></gtd-ui-field-default-boolean>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key"> <span i18n="@@offer.category">Category</span>: </span>
          <span class="value">
            <gtd-ui-field-default-string-or-empty [data]="data.category"></gtd-ui-field-default-string-or-empty>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key"> <span i18n="@@offer.traffic_source">Traffic Source</span>: </span>
          <span class="value">
            <gtd-ui-field-default-string-or-empty [data]="data.traffic_source"></gtd-ui-field-default-string-or-empty>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key"> <span i18n="@@offer.traffic_back_url">Traffic Back URL</span>: </span>
          <span class="value">
            <gtd-ui-field-default-string-whitespace-or-empty-with-copy
              [data]="data.trafficback_url"
            ></gtd-ui-field-default-string-whitespace-or-empty-with-copy>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.privacy">Privacy</span>: </span>
          <span class="value">
            <gtd-ui-field-default-string-whitespace-or-empty
              [data]="offer_privacy_translations[data.privacy] || data.privacy"
            ></gtd-ui-field-default-string-whitespace-or-empty>
          </span>
        </p>
      </li>
    </ul>
    <ul>
      <li class="title" i18n="@@common.additional">Additional</li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.description">Description</span>: </span>
          <span
            *ngIf="data.description || data.description_preset_id; else emptyTmpl"
            class="value c-field-value c-field-value--view-mode d-flex"
          >
            <span class="c-field-value__icon" (click)="openDescriptionModal()">
              <p500-ui-icon name="eye"></p500-ui-icon>
            </span>
            <span i18n="@@common.show">Show</span>
          </span>
          <ng-template #emptyTmpl>
            <gtd-ui-field-default-string-or-empty></gtd-ui-field-default-string-or-empty>
          </ng-template>
        </p>
      </li>
      <li *ngIf="data.hasOwnProperty('note')">
        <p>
          <span class="key"> <span i18n="@@common.note">Note</span>: </span>
          <span class="value">
            <gtd-ui-field-default-string-whitespace-or-empty [data]="data.note"></gtd-ui-field-default-string-whitespace-or-empty>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.created_at">Created At</span>: </span>
          <span class="value">
            <gtd-ui-field-default-datetime [data]="data.created_at * 1000"></gtd-ui-field-default-datetime>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.updated_at">Updated At</span>: </span>
          <span class="value">
            <gtd-ui-field-default-datetime [data]="data.updated_at * 1000"></gtd-ui-field-default-datetime>
          </span>
        </p>
      </li>
    </ul>
  </div>
</gtd-widgets-info-layout>
